<template>
  <modal-default
    ref="deactivateModal"
    title="Deactivate User"
  >
    <div class="modal-inner" v-if="user">
      <p class="deactivate_user--text"><strong>Are you sure you want to deactivate {{ user.full_name }}</strong>? The user will no longer have access to Forefront.</p>
      <p class="deactivate_user--text">Select a user to reassign any currently active records, incomplete tasks, and appointments.</p>
      <p class="deactivate_user--text mb-50">It will also update the following items that you should review to make sure the change was intended.</p>
      <ul class="deactivate_user--list">
        <li>Call Scripts</li>
        <li>Webhooks</li>
        <li>Phone Numbers</li>
        <li>Status Automations</li>
      </ul>
      <p class="deactivate_user--note"><strong>NOTE:</strong> Historical data associated with {{ user.full_name }} will not be lost.</p>

      <form-field-select
        label="Replacement User"
        v-model="replacementUserId"
        help-text="Note: It may take some time to transfer all the data depending on the amount of data associated to the user."
      >
        <option v-for="(replacement, index) in replacementUsers" :key="index" :value="replacement.id">
          {{ replacement.full_name }}
        </option>
      </form-field-select>
    </div>

    <template v-slot:footer>
      <button-default @click="deactivateUser" :loading="deactivating" :disabled="deactivating">
        Deactivate
      </button-default>
    </template>
  </modal-default>
</template>

<script>
export default {
  name: "DeactivateUserModal",
  data() {
    return {
      deactivating: false,
      replacementUserId: null,
      user: null
    }
  },
  computed: {
    replacementUsers() {
      return this.$store.getters.activeUsers.filter(u => u.id !== this.user.id);
    },
  },
  methods: {
    deactivateUser() {
      this.deactivating = true;
      this.$api.users.delete(this.user.id, {id: this.replacementUserId})
        .then(() => {
          this.$buefy.toast.open({
            message: "User has been deactivated",
            type: 'is-success'
          });

          this.$refs.deactivateModal.close();
        })
        .finally(() => { this.deactivating = false })
    },
    open(user = null) {
      this.user = user;
      this.replacementUserId = this.replacementUsers[0].id;
      this.$refs.deactivateModal.open();
    }
  }
}
</script>

<style lang="scss" scoped>
.deactivate_user--text {
  margin-bottom: 1rem;
  line-height: 1.3;
}

.deactivate_user--list {
  margin-bottom: 1rem;
  margin-left: 24px;
  list-style: disc;

  li {
    margin-bottom: 4px;
  }
}

.deactivate_user--note {
  margin-bottom: 1.5rem;
  font-style: italic;
  font-size: 0.875rem;
  line-height: 1.3;
}
</style>
